import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import heroImage from '../assets/BabyBasketHomeScreen.webp';

function Home() {
  return (
    <div className="home-wrapper">
      <Helmet>
        <title>Bunny Boutique 321 | Melbourne, FL</title>
        <meta name="description" content="Welcome to Bunny Boutique 321! We are a Florida-based ethical breeder specializing in happy, healthy, and well-socialized TeddyWidders and beautiful bunny companions." />
        <link rel="canonical" href="https://bunnyboutique321.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Bunny Boutique 321 | Melbourne, FL" />
        <meta property="og:description" content="Welcome to Bunny Boutique 321! We are a Florida-based ethical breeder specializing in happy, healthy, and well-socialized TeddyWidders and beautiful bunny companions." />
        <meta property="og:url" content="https://bunnyboutique321.com/" />
        <meta property="og:image" content="https://bunnyboutique321.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Bunny Boutique 321 | Melbourne, FL" />
        <meta name="twitter:description" content="Welcome to Bunny Boutique 321! We are a Florida-based ethical breeder specializing in happy, healthy, and well-socialized TeddyWidders and beautiful bunny companions." />
        <meta name="twitter:image" content="https://bunnyboutique321.com/og-image.jpg" />
      </Helmet>

      {/* --- MODERN HERO SECTION --- */}
      <section className="hero-section">
        <div className="hero-inner">
          <div className="hero-content">
            <span className="hero-eyebrow">Heritage Bred &middot; Boutique Raised</span>
            <h1>Find Your Perfect <em>Furry</em> Companion</h1>
            <p>
              Specializing in happy, healthy, and well-socialized bunnies.
              Ethically raised with love and care to become the perfect, lifelong addition to your family.
            </p>
            <div className="hero-buttons">
              <Link to="/available" className="btn-primary">View Available Bunnies</Link>
              <Link to="/application" className="btn-secondary">Join the Waitlist</Link>
            </div>
          </div>

          <div className="hero-image-container">
             {/* High-quality placeholder - swap the src with your own best photo! */}
             <img
               src={heroImage}
               alt="Baby bunnies from Bunny Boutique 321 snuggled in a basket"
               className="hero-img"
               width="1170"
               height="1085"
               fetchPriority="high"
               decoding="async"
             />
             {/* Decorative floating element */}
             <div className="hero-badge">Mother Daughter Hobby Breeder</div>
          </div>
        </div>
      </section>

      {/* --- VISUAL DIRECTORY (FEATURE GRID) --- */}
      <section className="features-section container">
        <span className="eyebrow">Our Promise</span>
        <h2>Welcome to the Boutique</h2>

        <div className="feature-grid">
          {/* Card 1 */}
          <div className="feature-card">
            <h3>The Nursery</h3>
            <p>Browse our current litters and available bunnies who are ready to find their forever homes.</p>
            <Link to="/available" className="feature-link">See Available &rarr;</Link>
          </div>

          {/* Card 2 */}
          <div className="feature-card">
            <h3>Our Breeding Program</h3>
            <p>Meet the beautiful foundational Bucks and Does that make up the heart of our boutique.</p>
            <Link to="/our-bunnies" className="feature-link">Meet the Parents &rarr;</Link>
          </div>

          {/* Card 3 */}
          <div className="feature-card">
            <h3>Boutique & Supplies</h3>
            <p>Shop our handcrafted bunny accessories alongside our top-recommended starter kits.</p>
            <Link to="/merchandise" className="feature-link">Shop Now &rarr;</Link>
          </div>
        </div>
      </section>

    </div>
  );
}

export default Home;